// extracted by mini-css-extract-plugin
module.exports = {"title":"styles_title__3L6wa","description":"styles_description__3vxf0","checkbox":"styles_checkbox__p0lfy","button":"styles_button__R14Bx"};